import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const Ctx = createContext({ currency: "USD", setCurrency: () => {} });

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("ucsx_cur") || "USD");
  useEffect(() => { localStorage.setItem("ucsx_cur", currency); }, [currency]);
  const value = useMemo(() => ({ currency, setCurrency }), [currency]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useCurrency = () => useContext(Ctx);
